import { Tooltip as MuiTooltip } from '@mui/material';
import { ReactNode } from 'react';

interface TooltipProps {
  children: ReactNode;
  title: ReactNode;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end';
}

export default function Tooltip({
  children,
  title,
  placement = 'bottom',
}: TooltipProps): JSX.Element {
  return (
    <MuiTooltip title={title} placement={placement} role="tooltip">
      <span className="inline-flex items-center">{children}</span>
    </MuiTooltip>
  );
}
